export const importedEventTypes = {
    TOURNAMENT: 'tournament',
    LEAGUE: 'league',
};

export const IMPORTED_TOURNAMENT_ROUTE_PATH = '/tournaments/:eventId(\\d+)';
export const IMPORTED_LEAGUE_ROUTE_PATH = '/leagues/:eventId(\\d+)';

const NUMERIC_EVENT_ID_PATTERN = /^\d+$/;
const IMPORTED_EVENT_TYPE_VALUES = Object.values(importedEventTypes);

export const canBuildImportedEventPath = ({ importedEventType, eventId } = {}) => {
    return NUMERIC_EVENT_ID_PATTERN.test(String(eventId)) &&
        IMPORTED_EVENT_TYPE_VALUES.includes(importedEventType);
};

export const buildImportedEventPath = ({ importedEventType, eventId } = {}) => {
    if (!NUMERIC_EVENT_ID_PATTERN.test(String(eventId))) {
        throw new Error(`buildImportedEventPath: eventId must be numeric, received "${eventId}"`);
    }

    if (importedEventType === importedEventTypes.TOURNAMENT) {
        return `/tournaments/${eventId}`;
    }

    if (importedEventType === importedEventTypes.LEAGUE) {
        return `/leagues/${eventId}`;
    }

    throw new Error(`buildImportedEventPath: unknown importedEventType "${importedEventType}"`);
};
